import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dddaf81e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag_content" }
const _hoisted_2 = { class: "tag_content_input_field" }
const _hoisted_3 = { class: "icon_button" }

import InputField from '@/components/atoms/InputField'
import IconButton from '@/components/molecules/IconButton'
import i18n from '@/plugins/i18n'
import { Cameratag } from '@/@types/typescript-axios'
import { ref, withDefaults } from 'vue'

type tagParam = {
  code: string
  name: string
}

type PropsType = {
  tag: Cameratag
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagEditRow',
  props: {
    tag: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["editTag", "deleteTag"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'editTag', value: tagParam): void
  (e: 'deleteTag', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tag: Cameratag, disabled: boolean };



const useBorder = true
const useCircle = true
const tagName = ref(props.tag.tag_name)



const editTag = () => {
  const params = {
    code: props.tag.tag_code,
    name: tagName.value,
  }

  emit('editTag', params)
}

const deleteTag = () => {
  // TODO 共通のモーダルに変更
  if (confirm(i18n.global.t('tag_edit_row.sure_remove'))) {
    emit('deleteTag', props.tag.tag_code)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InputField), {
        modelValue: tagName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tagName).value = $event)),
        name: __props.tag.tag_code,
        disabled: __props.disabled,
        onKeypress: _withKeys(editTag, ["enter"])
      }, null, 8, ["modelValue", "name", "disabled", "onKeypress"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(IconButton), {
        "use-border": useBorder,
        "use-circle": useCircle,
        icon: "check",
        size: "S",
        disabled: __props.disabled,
        onClick: editTag
      }, null, 8, ["disabled"]),
      _createVNode(_unref(IconButton), {
        "use-border": useBorder,
        "use-circle": useCircle,
        icon: "delete",
        disabled: __props.disabled,
        size: "S",
        onClick: deleteTag
      }, null, 8, ["disabled"])
    ])
  ]))
}
}

})